import { render, staticRenderFns } from "./DetalleAlmacenes.vue?vue&type=template&id=4275d592&scoped=true"
import script from "./DetalleAlmacenes.vue?vue&type=script&lang=ts"
export * from "./DetalleAlmacenes.vue?vue&type=script&lang=ts"
import style0 from "./DetalleAlmacenes.vue?vue&type=style&index=0&id=4275d592&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4275d592",
  null
  
)

export default component.exports